export default __webpack_public_path__ + "static/media/avatar.d901196f.jpeg";